import script from "./StoriesMainWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./StoriesMainWrapper.vue?vue&type=script&setup=true&lang=js"

import "./StoriesMainWrapper.vue?vue&type=style&index=0&id=2648f332&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2648f332"]])

export default __exports__